import Link from '@mui/material/Link';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import typography from 'assets/theme/base/typography';
import { useIntl } from 'react-intl';
import { getPageURL, getUrlParameter } from 'utils/urlUtils';
import app from 'config/app.json';
import useConf from 'hook/useConf';
import { useGetConfigurationQuery } from 'services/applicationApi';
import AboutDialog from 'components/Navbars/PortalNavbar/AboutDialog';
import { useState } from 'react';

function Footer() {
  const { formatMessage: msg } = useIntl();
  const { getValue: conf } = useConf(useGetConfigurationQuery);

  const { size } = typography;

  const [aboutOpen, setAboutOpen] = useState(false);

  const links = [
    {
      href: msg({ id: 'company.website' }),
      name: msg({ id: 'company.name' })
    },
    {
      code: 'about',
      name: msg({ id: 'about.name' })
    }
  ];

  if (conf('ui.page.accessibility')) {
    links.push({
      href: getPageURL('accessibility', getUrlParameter(window.location, app.url.paramApp)),
      name: msg({ id: 'accessibility.name' })
    });
  }
  const handleLinkClick = (code) => {
    if (code === 'about') {
      setAboutOpen(true);
    }
  };

  const handleAboutClose = () => {
    setAboutOpen(false);
  };

  const renderLinks = () =>
    links.map((link) => (
      <MDBox key={link.name} component="li" px={2} lineHeight={1}>
        <Link
          href={link.href ?? undefined}
          target={link.href ? '_blank' : undefined}
          rel={link.href ? 'noopener noreferrer' : undefined}
          onClick={() => handleLinkClick(link.code)}
        >
          <MDTypography
            variant="button"
            sx={{ fontWeight: 'regular', textDecoration: 'underline', cursor: 'pointer' }}
          >
            {link.name}
          </MDTypography>
        </Link>
      </MDBox>
    ));

  return (
    <MDBox
      width="100%"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
      mt={1}
    >
      <MDBox
        component="ul"
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          listStyle: 'none',
          mb: 0,
          p: 0
        }}
      >
        {renderLinks()}
      </MDBox>
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={size.sm}
        px={1.5}
      >
        &copy; {new Date().getFullYear()}
        <Link href={msg({ id: 'product.website' })} target="_blank">
          <MDTypography variant="button" sx={{ fontWeight: 'medium', textDecoration: 'underline' }}>
            &nbsp;{msg({ id: 'product.name' })}&nbsp;
          </MDTypography>
        </Link>
      </MDBox>

      <AboutDialog open={aboutOpen} onClose={handleAboutClose} />
    </MDBox>
  );
}

export default Footer;
